import { TradeInsuranceStatus } from "../../graphql/generated.ts";

export enum TabValue {
  CollectionDashboard = "collectionDashboard",
  TradeInsuranceDashboard = "tradeInsuranceDashboard",
}

export interface CollectionDashboardFilter {
  salesTeam?: string[];
  restructure?: boolean;
}

export interface TradeInsuranceDashboardFilter {
  insuranceName?: string;
  customerId?: string[];
  status?: TradeInsuranceStatus;
}
